export default String.raw`
<dialog class="dialog sizeChart sizeChart-popup-js">
    <div class="dialog__header">
        <h2 class="dialog__header-title">{{ translations.SizeChart }}</h2>
        <form method="dialog">
            <button class="dialog__close close-js" aria-label="{{ translations.Close }}">
                <svg aria-hidden="true" height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        </form>
    </div>
    <div class="dialog__content">
        <div class="sizeChart__info">
            {% assign banner = config.Banners['SizeTable'] -%}
            {% for slide in banner.Images -%}
                <div class="bannerItemContainer">
                    <p class="bannerHeading">{{slide.Heading}}</p>
                    <p>{{slide.Text}}</p>
                    <div class="imgContainer">
                        <img class="imgContainer--image {% if slide.Title == 'table' -%} table {% elsif slide.Title == 'contour' -%} contour {% endif -%}" src="css/img/alo.gif" data-src="{{slide.Url}}" alt="{{slide.Alt}}">
                    </div>
                </div>
            {% endfor -%}
        </div>
    </div>
</dialog>
`